import React from "react";
import Services from "../components/AboutUs/Services";
import Newsletter from "../components/Homepage/Newsletter";
import Footer from "../components/Common/Footer";
import MissionVision from "../components/AboutUs/MissionVision";
import Header from "../components/Common/Header/Header";

const About = () => {
  return (
    <>
      <Header />
      <MissionVision />
      <Services />
      <Newsletter />
      <Footer />
    </>
  );
};

export default About;
